import React from 'react';
import DoubleArrowSharpIcon from '@material-ui/icons/DoubleArrowSharp';
import { makeStyles } from '@material-ui/core/styles';

type StyleProps = {
    rotateDegree: number;
};

const useStyles = makeStyles({
    rotatedIcon: (props: StyleProps) => ({
        transform: `rotate(${props.rotateDegree}deg)`,
        fontSize: '18px', // Custom size
        cursor: 'pointer',
        marginLeft: '5px',
        fontWeight: 300,
    }),
});

type RotatedIconProps = {
    isExpanded: boolean;
};

const RotatedIcon = ({ isExpanded }: RotatedIconProps) => {
    const rotateDegree = isExpanded ? -90 : 90;
    const classes = useStyles({ rotateDegree });

    return (
        <DoubleArrowSharpIcon className={classes.rotatedIcon} />
    );
};

export default RotatedIcon;
